import React, { useState, useEffect } from "react";

// Material UI
import AvatarGroup from '@mui/material/AvatarGroup';
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import { Link, useLocation } from 'react-router-dom';




// Local
import MessageGroup from "./MessageGroup";
import { PersonIcon } from "./PersonIcon";


const Conversation = React.memo(function Conversation(props) {
  const location = useLocation();
  // const messageGroups = [];

  function getSender(messageGroup) {
    // Message Groups are organized by sender, so
    // sender value is the same for all messages
    // in a Message Group.

    return messageGroup ? messageGroup.content[0].sender : "";
  }

  function getStartDate(messageGroup) {
    if (!messageGroup) return;
    return new Date(messageGroup.content[0].date).toLocaleDateString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  }

  function getDate(messageGroup) {
    return new Date(messageGroup.content[0].date).toLocaleDateString("en-US", {
      month: "numeric",
      day: "2-digit",
      year: "2-digit",
      hour: "numeric",
      minute: "numeric",
      timeZoneName: "short",
    });
  }



	function prepareName(obj, number, include_number=true) {
		if (obj === null) {
			return number;
		}
		else {
			var name = obj;
			if (include_number) {
				name += " (" + number + ")";
			}
			return name;
		}
  }

  function getParticipantHeader(messageGroups) {
    if (!messageGroups || !messageGroups.length) return;

    // Extract unique participants from ALL messages (senders and recipients)
    const participantMap = new Map();

    messageGroups.forEach(messageGroup => {
      if (messageGroup.content && messageGroup.content.length > 0) {
        messageGroup.content.forEach(message => {
          // Add sender
          if (message.sender && !participantMap.has(message.sender)) {
            participantMap.set(message.sender, {
              name: message.name || message.sender,
              initials: message.initials || message.sender.slice(-2)
            });
          }

          // Add recipients (if they exist)
          if (message.recipients && Array.isArray(message.recipients)) {
            message.recipients.forEach(recipient => {
              if (recipient && !participantMap.has(recipient)) {
                // Recipients won't have name/initials in the message, so use fallback
                participantMap.set(recipient, {
                  name: recipient,
                  initials: recipient.slice(-2)
                });
              }
            });
          }
        });
      }
    });

    // Convert to array and format names
    const participantNames = Array.from(participantMap.values())
      .map(p => p.name)
      .filter(name => name !== null && name !== undefined);

    return participantNames.join(', ');
  }

	function prepareInitials(obj, number) {
		if (obj === null) {
			if (number === null) {
				return '?';
			}
			return number.slice(-2);
		}
		else {
			return obj;
		}
  }

  const searchParams = new URLSearchParams(location.search);
  let requested_view_as = searchParams.get('view_as');
  let focus = searchParams.get('focus');

  if (requested_view_as === null || requested_view_as === undefined) {  
    requested_view_as = props.threadData.messages[0]['meta']['view_as']
    if (requested_view_as === undefined || requested_view_as === null) {
      requested_view_as = [getSender(props.threadData.messages[0])];
    }
  }
  else {
    if (typeof requested_view_as === 'string') {
      requested_view_as = requested_view_as.split(',');
    }
  }

  const [viewAs, setViewAs] = useState(requested_view_as);
  const [assignments, setAssignments] = useState([]);
  const [messageGroups, setMessageGroups] = useState([]);
  const [threadId, setThreadId] = useState([]);
  const [focusMessage, setFocusMessage] = useState(focus);

  useEffect(() => {
    setMessageGroups(props.threadData.messages);
    setViewAs(requested_view_as);
		setAssignments(props.assignmentData);
    setThreadId(props.id);

    // Update focus from URL when component mounts or props change
    const searchParams = new URLSearchParams(location.search);
    setFocusMessage(searchParams.get('focus'));

  }, [props, location]);

	useEffect(() => {
    if (focusMessage && messageGroups.length > 0) {
      // Add a small delay to ensure the DOM has rendered
      setTimeout(() => {
        var item = document.getElementById("message_id_" + focusMessage);
        if (item) {
          item.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});

          // Add highlighting animation to just the specific message
          // Store the original styles
          const originalBackgroundColor = window.getComputedStyle(item).backgroundColor;
          const originalColor = window.getComputedStyle(item).color;

          // Apply highlight without changing layout
          item.style.transition = 'background-color 0.3s ease-in-out, color 0.3s ease-in-out';
          item.style.backgroundColor = '#ffff99'; // Yellow highlight
          item.style.color = '#000000'; // Black text for better contrast on yellow

          // Fade back to original styles after 2 seconds
          setTimeout(() => {
            item.style.backgroundColor = originalBackgroundColor;
            item.style.color = originalColor;

            // Remove the transition after fade completes
            setTimeout(() => {
              item.style.transition = '';
              item.style.backgroundColor = '';
              item.style.color = '';
            }, 300);
          }, 2000);
        }
      }, 100);
    }
	}, [focusMessage, messageGroups]);


  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const viewThread = () => {
    setAnchorEl(null);
  }

  const handleViewAsChange = (newViewAsNumber) => {
    // Update the viewAs state
    const newViewAs = [newViewAsNumber];
    setViewAs(newViewAs);

    // Update URL parameters without triggering navigation
    const newUrl = new URL(window.location);
    newUrl.searchParams.set('view_as', newViewAsNumber);
    window.history.replaceState(null, '', newUrl.toString());
  }

  return (
    // <Grid>
    // </Grid>
    <Card>
      <CardHeader
        avatar={
          <AvatarGroup>
            {messageGroups
              ? (() => {
                  // Extract unique participants from ALL messages (senders and recipients)
                  const participantMap = new Map();
                  messageGroups.forEach(messageGroup => {
                    if (messageGroup.content && messageGroup.content.length > 0) {
                      messageGroup.content.forEach(message => {
                        // Add sender
                        if (message.sender && !participantMap.has(message.sender)) {
                          participantMap.set(message.sender, {
                            name: message.name || null,
                            number: message.sender,
                            initials: message.initials || prepareInitials(null, message.sender)
                          });
                        }

                        // Add recipients (if they exist)
                        if (message.recipients && Array.isArray(message.recipients)) {
                          message.recipients.forEach(recipient => {
                            if (recipient && !participantMap.has(recipient)) {
                              // Recipients won't have name/initials in the message, so use fallback
                              participantMap.set(recipient, {
                                name: null,
                                number: recipient,
                                initials: prepareInitials(null, recipient)
                              });
                            }
                          });
                        }
                      });
                    }
                  });

                  return Array.from(participantMap.values()).map((participant) => (
                    <PersonIcon
                      key={participant.number}
                      name={participant.name}
                      number={participant.number}
                      info={prepareName(participant.name, participant.number)}
                      initials={participant.initials}
                      owner={viewAs.includes(participant.number)}
                      onViewAsChange={handleViewAsChange}
                    />
                  ));
                })()
              : null}
          </AvatarGroup>
        }
        action={
          <div>
          <IconButton aria-label="settings" onClick={handleClick} size="large">
            <MoreVertIcon />
          </IconButton>
          <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          >

          <MenuItem onClick={viewThread} component={Link} to={'/thread/' + threadId + "?view_as=" + viewAs.join(',')}>
            
            View Thread Across All Requests
            
          </MenuItem>
          </Menu>
          </div>
        }
        title={getParticipantHeader(messageGroups)}
        subheader={getStartDate(messageGroups[0])}
      />
      <CardContent variant="outlined">
        {messageGroups.map((messageGroup) => {
          const sender = getSender(messageGroup);
          return (
            <MessageGroup
              messages={messageGroup.content}
              assignments={assignments}
              owner={messageGroup.meta.view_as ? messageGroup.meta.view_as.includes(sender) : viewAs.includes(sender)}
              sender={sender}
              date={
                messageGroup.meta.shows_timestamp ? getDate(messageGroup) : ""
              }
							name={messageGroup.meta.name}
							initials={prepareInitials(messageGroup.meta.initials, sender)}
							thread_id={threadId}
							onViewAsChange={handleViewAsChange}
            />
          );
        })}
        
      </CardContent>
    </Card>
  );
});

export default Conversation;
